export default "__VITE_ASSET__CjnGleLX__"